import React, {useState} from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from "../../../../Hooks/useFormName";
import TopFieldContent from "../../../../Components/Form/components/TopFieldContent";
import ErrorMessage from "../../../../Components/Form/components/ErrorMessage";
import Select, {SelectValueProps} from "../../../../Components/Form/components/Select";
import {useEffectAsync} from "../../../../helpers";
import {useLazyNcziListEnumItemsQuery} from "../../../../graphql/graphql";
import {SelectValue} from "../../../../Components/Base/Select/Select";
import { NCZIReferenceSelectError } from '../ReferenceSearchSelect/NCZIReferenceSearchSelectField';

interface Props {
	label?: string;
	name: string;
	isRequired?: boolean;
	className?: string;
	oid: string;
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
}

const NCZIReferenceSelectField: React.FC<Props> = (props) => {
	const { name, label, className, isRequired, oid, onChange, value } = props;
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	const [options, setOptions] = useState<SelectValueProps[]|undefined>([]);
	const [getListEnumItems] = useLazyNcziListEnumItemsQuery();

	useEffectAsync(async () => {
		if (value) onChange?.(value);

		await loadItems();
	});

	const loadItems = async () => {
		const {items: listEnumItems} = await getListEnumItems({
			oid,
			take: 999
		}).unwrap();

		const items: SelectValueProps[] = [];

		for (const listEnumItem of listEnumItems?.data || []) {
			if (listEnumItem) {
				items.push({
					label: listEnumItem.name || '',
					value: {
						displayName: listEnumItem.name || '',
						code: listEnumItem.code,
						scheme: {
							oid: listEnumItem.enum?.oid || '',
							version: listEnumItem.enum?.version || ''
						}
					}
				});
			}
		}

		setOptions(items);
	};

	if(typeof options === 'undefined') {
		return <></>;
	}

	const referenceError = error as NCZIReferenceSelectError;

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<Select
				options={options}
				{...props}
				{...field}
				hasError={!!referenceError?.value?.code?.message}
			/>
			{referenceError?.value?.code?.message && <ErrorMessage tx={referenceError?.value?.code?.message} />}
		</div>
	);
};

export default NCZIReferenceSelectField;
